import type {
  ChangesResponse,
  EntityType,
  HeadResponse,
  PushRequest,
  PushResponse,
  SnapshotResponse,
} from '@fd/schemas';

/** How the engine talks to the backend (Supabase Edge Function or the local dev host). */
export interface SyncTransport {
  push(request: PushRequest): Promise<PushResponse>;
  changes(householdId: string, cursor: number, limit: number): Promise<ChangesResponse>;
  head(householdId: string): Promise<HeadResponse>;
  snapshot(
    householdId: string,
    entityType: EntityType,
    after: string | null,
    limit: number,
    since: string | null,
  ): Promise<SnapshotResponse>;
  resolveConflict(
    householdId: string,
    conflictId: string,
    resolution: 'SERVER' | 'CLIENT' | 'MERGED',
    operationId: string | null,
  ): Promise<void>;
}

/** A failed request. `retryable` = network, timeout, 5xx, 429 — the outbox keeps the change. */
export class TransportError extends Error {
  readonly status: number | null;
  readonly code: string;
  readonly retryable: boolean;
  readonly correlationId: string | null;
  constructor(message: string, options: { status: number | null; code: string; retryable: boolean; correlationId?: string | null }) {
    super(message);
    this.name = 'TransportError';
    this.status = options.status;
    this.code = options.code;
    this.retryable = options.retryable;
    this.correlationId = options.correlationId ?? null;
  }
}
